angular.
module("dx.webapp.node").
constant("DX_REMOTE_PROCTOR_SETTING", Object.freeze({
	ProctoringNone: 0,
	ProctoringEnabled: 1,
	ProctoringStartFacePhoto: 2,
	ProctoringStartIDPhoto: 4,
	ProctoringRecordVideo: 8,
	ProctoringScreenCapture: 16,
	ProctoringTrackMetrics: 32,
	ProctoringProctorChat: 64,
	ProctoringAutoConclude: 128,
	ProctoringMobileCamera: 256,
}));
